import { render, staticRenderFns } from "./QuestionImageHorizontalV3Math.vue?vue&type=template&id=9dacfbbc&scoped=true&lang=pug&"
import script from "./QuestionImageHorizontalV3Math.vue?vue&type=script&lang=ts&"
export * from "./QuestionImageHorizontalV3Math.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionImageHorizontalV3Math.vue?vue&type=style&index=0&id=9dacfbbc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dacfbbc",
  null
  
)

export default component.exports